export enum WidgetOptionsActionType {
    SET_SAVE_BUTTON_DISABLED = 'setSaveButtonDisabled',
}

export interface SetSaveButtonDisabledAction {
    type: WidgetOptionsActionType.SET_SAVE_BUTTON_DISABLED
    payload: boolean
}

export interface WidgetOptionsState {
    saveButton: {
        disabled: boolean
    }
}

export type WidgetOptionsAction = SetSaveButtonDisabledAction

export const widgetOptionsInitialState: WidgetOptionsState = {
    saveButton: {
        disabled: false,
    },
}

export const widgetOptionsReducer = (
    state: WidgetOptionsState,
    action: WidgetOptionsAction,
) => {
    switch (action.type) {
        case WidgetOptionsActionType.SET_SAVE_BUTTON_DISABLED:
            return {
                ...state,
                saveButton: {
                    disabled: action.payload,
                },
            }
        default:
            return state
    }
}
